import { normalQueryTypes } from '@ow/utils'

const filterSpec = {
  queryTypes: ['containArray'].map((p) => normalQueryTypes[p]),
}

export { filterSpec }

export const config = {
  slug: '',
  title: '指标',
  type: 'standard',
  intro: '指标设置',
  required: false,
  description: '字段描述',
  readonly: false,
  hidden: false,
  defaultValue: [],
}
